import React, { useEffect, useRef } from "react";
import CustomInput from "../CustomInput";
import CustomCalender from "./CustomCalender";
import utils from "../../utils";

import './index.scss';

type Props = {
  onChange?: (arg: any) => void;
  defaultValue?: string | undefined;
  minDate?: Date;
  maxDate?: Date;
  placeholder?: string;
  format?: string;
  isIsoDate?: boolean;
  isRemoveable?: boolean;
};

const CustomTimePiker = (props: Props) => {
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const selectTimePikerRef = useRef<HTMLElement | null>(null);

  useEffect((): void => {
    document.addEventListener("mousedown", (event: any) => {
      if (!selectTimePikerRef?.current?.contains(event.target)) {
        setShowModal(false);
      }
    });
  }, []);

  return (
    <section id="custom-time-piker-container" ref={selectTimePikerRef}>
      <CustomInput
        placeHolder={props.placeholder}
        onClick={() => setShowModal(true)}
        value={
          props?.defaultValue
            ? utils.convertGregorianToJalali({
                date: props.defaultValue,
                format: 'jYYYY/jMM/jDD',
              })
            : ''
        }
        inputSize="large-input"
        leftIcon={props?.isRemoveable ? 'fa-solid fa-x' : ''}
        onClickLeftIcon={() =>
          props?.isRemoveable ? props.onChange!(props?.isIsoDate ? new Date() : new Date().toISOString()) : false
        }
      />
      <CustomCalender
        defaultValue={props.defaultValue}
        minDate={props.minDate}
        maxDate={props.maxDate}
        isShow={showModal}
        onDateSelected={(event: any): void => {
          props.onChange!(
            utils.convertJalaliToGregorian({
              date: event,
              format: props?.format ? props.format : 'YYYY/MM/DD',
            })
          );
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default CustomTimePiker;
